export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = () => {
      // Fallback: create a colored rectangle if image fails to load
      const canvas = document.createElement('canvas');
      canvas.width = 64;
      canvas.height = 48;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ff6b6b';
      ctx.fillRect(0, 0, 64, 48);
      resolve(canvas);
    };
  });
}

